import { render } from "./GuiQuestionTypeSelect.vue?vue&type=template&id=50c279c3"
import script from "./GuiQuestionTypeSelect.vue?vue&type=script&lang=js"
export * from "./GuiQuestionTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__